import React, { useState } from "react";
import { AutoComplete, Input } from "antd";

/* =====================================================
   Cookie-based search history + pagination memory
   ใช้ร่วมกันทุกหน้า Access:
     const { searchHistory, saveSearchHistory, pagination, handlePageChange } =
       useSearchCookies("page_key");
   ===================================================== */

const HISTORY_MAX = 5;
const COOKIE_AGE = 60 * 60 * 24 * 365; // 1 ปี

export const getCookieJSON = (name, fallback) => {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
    return m ? JSON.parse(decodeURIComponent(m[1])) : fallback;
  } catch {
    return fallback;
  }
};

export const setCookieJSON = (name, value) => {
  document.cookie = `${name}=${encodeURIComponent(
    JSON.stringify(value)
  )};path=/;max-age=${COOKIE_AGE}`;
};

export const useSearchCookies = (pageKey) => {
  const historyKey = `${pageKey}_search_history`;
  const pageCookie = `${pageKey}_pagination`;

  const [searchHistory, setSearchHistory] = useState(
    getCookieJSON(historyKey, {})
  );
  const [pagination, setPagination] = useState(
    getCookieJSON(pageCookie, { current: 1, pageSize: 10 })
  );

  // เก็บเฉพาะ field ที่เป็น string ไม่ว่าง (ข้าม DatePicker/undefined)
  const saveSearchHistory = (values = {}) => {
    const next = { ...searchHistory };
    let changed = false;
    Object.keys(values).forEach((k) => {
      const val = typeof values[k] === "string" ? values[k].trim() : "";
      if (!val) return;
      next[k] = [val, ...(next[k] || []).filter((t) => t !== val)].slice(
        0,
        HISTORY_MAX
      );
      changed = true;
    });
    if (!changed) return;
    setCookieJSON(historyKey, next);
    setSearchHistory(next);
  };

  const handlePageChange = (current, pageSize) => {
    const next = { current, pageSize };
    setCookieJSON(pageCookie, next);
    setPagination(next);
  };

  return { searchHistory, saveSearchHistory, pagination, handlePageChange };
};

/* Input + dropdown ประวัติการค้นหา (ใช้แทน <Input> ใน Form.Item) */
export const HistoryInput = ({
  value,
  onChange,
  history = [],
  onSearch,
  onCommit,
  placeholder,
  ...rest
}) => (
  <AutoComplete
    value={value}
    options={(history || []).map((v) => ({ value: v }))}
    onChange={(v) => {
      onChange?.(v);
      onSearch?.();
    }}
    onSelect={() => onCommit?.()}
    onBlur={() => {
      // บันทึกประวัติเมื่อออกจากช่อง (กรณีพิมพ์แล้วไปคลิกอย่างอื่นเลย)
      if ((value || "").trim()) onCommit?.();
    }}
    style={{ width: "100%" }}
  >
    <Input
      placeholder={placeholder}
      onPressEnter={() => onCommit?.()}
      {...rest}
    />
  </AutoComplete>
);
